import { render, staticRenderFns } from "./openapp.vue?vue&type=template&id=f08e9768&"
import script from "./openapp.vue?vue&type=script&lang=ts&"
export * from "./openapp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports